// extracted by mini-css-extract-plugin
export default {"wrapper":"About_wrapper__taOJB","image":"About_image__bsB3s","descriptor":"About_descriptor__mFgEz"};